import { render, staticRenderFns } from "./ClientPanelUser.vue?vue&type=template&id=2f947092&"
import script from "./ClientPanelUser.vue?vue&type=script&lang=js&"
export * from "./ClientPanelUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports